// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "." + "a76c4294101e2e2481c2" + ".chunk.css";
};